export class SimpleArticlesListModule {

	constructor() {
		if ($(".component-simple-article").length > 0) {
			this.init();
		}
	}

	init() {

		$(".js-article-simple-show-more-button").on("click", function (e) {
			var that = this;

			console.log(that);

			$(".js-article-listing-full-width-simple").find(".article-item-hide").nextAll().addBack().slice(0, 3).removeClass("article-item-hide");

			let remainingHidden = $(that).find(".article-item-hide").length;

			if (remainingHidden == 0) {
				$(that).hide();
			}

		});
	}

}